var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.getId},domProps:{"textContent":_vm._s(_vm.getLabel)}}),_vm._v(" "),_c('async-selector',{attrs:{"api-url":"/api/backend/composer/resources/products/","selected":_vm.currentIds,"multiple":true},on:{"updated":_vm.selectorUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }